import { Div, P } from '@kizi/core-components';
import React, { useEffect, useState } from 'react';
import {
  IconV2 as Icon,
  IconV2Props as IconProps,
  Slider,
  SliderProps,
  Row,
} from '@kizi/shared-components';
export interface ReviewsCarouselProps extends Partial<SliderProps> {
  title: string;
  iconProps?: Omit<IconProps, 'name'>;
  nextSlideIcon?: string;
  previousSlideIcon?: string;
}

export const getNextPage = (currentPage, numberOfPages) => {
  const lastPageIndex = numberOfPages - 1;
  if (currentPage < lastPageIndex) return currentPage + 1;
  return lastPageIndex;
};

export const getPreviousPage = (currentPage) => {
  if (currentPage > 0) return currentPage - 1;
  return 0;
};

export const ReviewsCarousel = ({
  elements = [],
  iconProps,
  nextSlideIcon = 'arrow-right',
  previousSlideIcon = 'arrow-left',
  title,
}: ReviewsCarouselProps) => {
  return (
    <Slider elementsPerPage={[1, 1, 2, 2]} elements={elements}>
      {(visibleElements, currentPage, setPage, numberOfPages) => {
        const [_currentPage, setCurrentPage] = useState(currentPage || 0);
        useEffect(() => {
          setPage(_currentPage);
        }, [_currentPage]);

        const nextIconVariant =
          _currentPage === 0 ? 'iconLinkDisabled' : 'iconLink';
        const previousIconVariant =
          _currentPage === numberOfPages - 1 ? 'iconLinkDisabled' : 'iconLink';

        return (
          <Div mt={8}>
            <Div display="flex" justifyContent="space-between">
              <P mb={3} variant="bodyImportant">
                {title}
              </P>
              <Div display="flex">
                <Div
                  mr={3}
                  onClick={() => {
                    setCurrentPage(getPreviousPage(_currentPage));
                  }}
                  role="button"
                >
                  <Icon
                    name={previousSlideIcon}
                    variant={nextIconVariant}
                    {...iconProps}
                  />
                </Div>
                <Div
                  onClick={() => {
                    setCurrentPage(getNextPage(_currentPage, numberOfPages));
                  }}
                  role="button"
                >
                  <Icon
                    name={nextSlideIcon}
                    variant={previousIconVariant}
                    {...iconProps}
                  />
                </Div>
              </Div>
            </Div>
            <Row
              justifyItems="center"
              gridRowGap={[0, 0, 0]}
              gridColumnGap={[0, 0, 4]}
              cols={[1, 1, 2]}
            >
              {visibleElements}
            </Row>
          </Div>
        );
      }}
    </Slider>
  );
};
